import React, { useState, useEffect } from "react";
import {
  HeartIconOrange,
  HeartIconBlueBorder
} from "../../../../assets/icons/icon";
import "./index.scss";
import { getDate, getOnlyTime } from "../../../../utils/date";
import { getBase64 } from "../../../../utils/base64";
import { uploadFile } from "../../../../data/Shared/upload-file";
import { ListLoader } from "../../../Layout/Shared/DataLoading";
import { CustomSelectFile } from "../../../Layout/Shared/SelectFile";
import DefaultImage from "../../../../assets/images/default-profile-picture.png";

export const ClientCard = ({
  id,
  fullName,
  created_at,
  profilePictureUrl,
  setProfilePictureUrl,
  isFavorite,
  setIsFavorite,
  disabled
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [infoMessage, setInfoMessage] = useState(null);

  const handleFile = async ({ files }) => {
    setIsLoading(true);
    const file = files[0];
    const body = {
      name: file.name,
      type: file.type,
      file: await getBase64(file),
      source: "profile-picture",
      rootPath: `clients/${id}`
    };
    const { hasSuccess, data } = await uploadFile(body);
    hasSuccess && setProfilePictureUrl(data.Location);
    setIsLoading(false);
  };

  useEffect(() => {
    const timeId = setTimeout(() => setInfoMessage(null), 4000);
    return () => clearTimeout(timeId);
  }, [infoMessage]);

  return (
    <div className="contact-profile-card">
      <div className="row">
        <div className="col-12 text-center p-5 contact-profile-picture">
          <h2>
            {fullName}
            <button
              className="btn-icon"
              onClick={() => setIsFavorite(!isFavorite)}
              disabled={disabled}
            >
              {isFavorite ? HeartIconOrange : HeartIconBlueBorder}
            </button>
          </h2>
          <figure className="border rounded-xxl overflow-hidden">
            <img
              src={profilePictureUrl ?? DefaultImage}
              onLoad={() =>
                setTimeout(() => {
                  setIsLoading(false);
                }, 500)
              }
              alt=""
              style={{
                display: isLoading ? "none" : "flex"
              }}
            />
            {isLoading && <ListLoader height={"213px"} />}
          </figure>
          <CustomSelectFile
            color="solid-blue"
            label="Upload Your Picture"
            size="210px"
            onChange={e => handleFile(e.target)}
            accept="image/*"
            disabled={disabled}
          />
        </div>
        <div className="border-top w-100">
          <div className="group-section">
            <div className="action-buttons"></div>
            <div className="created mt-5">
              <span>Date Created</span>
              <span>
                {getDate(created_at)} | {getOnlyTime(created_at)}
              </span>
            </div>
          </div>
        </div>
      </div>
      {infoMessage && (
        <div className="notifications">
          <div className="info">
            <span>Info</span>
            <p>{infoMessage}</p>
            <button onClick={() => setInfoMessage(null)}>&times;</button>
          </div>
        </div>
      )}
    </div>
  );
};
